import React, { useState, useEffect } from 'react';
import { LuChevronRight, LuChevronDown } from "react-icons/lu"; 
import "../../asset/css/register.css";
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "../../asset/img/white.png";

const Privacy = () => {
   
  return (
    <div className="register-wrapper">
      <nav className="reg-nav">
        <div className="reg-logo">
          <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    {/* <div className="sub-brand  text-dark">Project Management Dashboard</div> */}
    </div>
        </div>
        <div className="login-link">
          Already have an account? <a href="/login">Log in</a>
        </div>
      </nav>

    











<section class="page-content">
    <div class="container">
      <span class="last-updated"><i class="far fa-calendar-alt" style={{marginRight: "6px;"}}></i> Last Updated: May 1, 2026</span>

      <h1><i class="fas fa-lock"></i> Privacy Policy</h1>
      <p class="intro">
        At <strong>Measro</strong>, we take your privacy seriously. This policy explains how we collect, use, and protect your information when you use our GIS property measurement services — built for professionals who demand accuracy and trust.
      </p>

       
      <h2><i class="fas fa-database"></i> 1. Information We Collect</h2>
      <p>When you use Measro, we may collect the following types of information to deliver our services and improve your experience:</p>
      <ul>
        <li><strong>Contact Information</strong> — Your name, email address, phone number, and company name when you book a demo, create an account, or contact us.</li>
        <li><strong>Property Information</strong> — Street addresses, coordinates, or parcel IDs that you submit for measurement analysis.</li>
        <li><strong>Usage Data</strong> — Pages visited, time spent on our platform, and interaction with our tools to improve your experience.</li>
        <li><strong>Payment Information</strong> — Billing details processed securely through our payment partner (we do not store full credit card numbers).</li>
      </ul>

    
      <h2><i class="fas fa-cog"></i> 2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Process and deliver your GIS measurement reports</li>
        <li>Communicate about your account, orders, and support inquiries</li>
        <li>Improve our platform, features, and user experience</li>
        <li>Send relevant product updates, tips, and promotional offers (you can opt out anytime)</li>
        <li>Comply with legal obligations and prevent fraud</li>
      </ul>

      <div class="highlight-box">
        <p><i class="fas fa-shield-alt"></i> We never sell, rent, or share your personal information with third parties for their own marketing purposes. Your data stays yours.</p>
      </div>

      
      <h2><i class="fas fa-satellite"></i> 3. How We Use Nearmap &amp; GIS Data</h2>
      <p>Measro uses Nearmap aerial imagery and GIS technology to generate property measurements. Property addresses you submit are used solely for measurement analysis and are not shared with third parties except as necessary to process your request (e.g., with Nearmap for imagery access). All measurement data belongs to you.</p>

     
      <h2><i class="fas fa-lock"></i> 4. Data Security</h2>
      <p>We implement industry-standard security measures including SSL encryption, secure servers, and regular security audits to protect your data. Access to personal information is restricted to authorized team members only.</p>

       
      <h2><i class="fas fa-cookie-bite"></i> 5. Cookies</h2>
      <p>Measro uses essential cookies to keep your session secure and functional. We also use analytics cookies (like Google Analytics) to understand how our site is used. You can control cookie preferences through your browser settings.</p>

      
      <h2><i class="fas fa-user-check"></i> 6. Your Rights</h2>
      <p>Depending on your location (including US state laws like CCPA and Canadian PIPEDA), you may have the right to:</p>
      <ul>
        <li>Access, correct, or delete your personal data</li>
        <li>Opt out of marketing communications</li>
        <li>Request a copy of your data in a portable format</li>
        <li>Withdraw consent where processing is based on consent</li>
      </ul>
      <p>To exercise any of these rights, email us at <a href="mailto:support@measro.com">support@measro.com</a>.</p>

     
      <h2><i class="fas fa-handshake"></i> 7. Third-Party Services</h2>
      <p>We use trusted third-party services for payment processing, email communication, and analytics. These providers are contractually obligated to protect your data and use it only for the services we request.</p>

      
      <h2><i class="fas fa-child"></i> 8. Children's Privacy</h2>
      <p>Measro is intended for business and professional use. We do not knowingly collect information from children under 13.</p>

     
      <h2><i class="fas fa-edit"></i> 9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. We'll notify you of significant changes via email or a notice on our website. Continued use of Measro after changes means you accept the updated policy.</p>

   
      <h2><i class="fas fa-envelope"></i> 10. Contact Us</h2>
      <p>Questions about this Privacy Policy? Reach out to us — we're here to help.</p>

      <div class="contact-block">
        <ul>
          <li><strong>Email:</strong> <a href="mailto:support@measro.com">support@measro.com</a></li>
          <li><strong>Address:</strong> Measro LLC., 30 N Gould St Ste R, Sheridan WY 82801</li>
        </ul>
      </div>

   
      <div style={{marginTop: "36px", paddingTop: "24px", borderTop: "1px solid var(--border)"}}>
        <p style={{fontSize: "14px", color: "var(--text-lighter);"}}>
          <i class="fas fa-info-circle" style={{color: "var(--primary)", marginRight: "6px;"}}></i>
          <strong>Measro’s commitment:</strong> We built this policy with transparency in mind. Every data point we collect serves a clear purpose — to give you precise, reliable property measurements while respecting your privacy. If you ever have questions, our team is just an email away.
        </p>
      </div>

    </div>
  </section>

 
 <footer>
    <div class="container">
      <p>
        &copy; 2026 Measro LLC. All rights reserved.
        <span class="footer-divider">|</span>
        <a href="/privacy">Privacy Policy</a>
        <span class="footer-divider">|</span>
        <a href="/terms">Terms of Service</a>
      </p>
    </div>
  </footer>






<style>
  {`
  

  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    :root {
      --primary: #4E46E4;
      --primary-dark: #4E46E4;
      --primary-light: #c77dff;
      --primary-bg: rgba(157, 78, 221, 0.07);
      --primary-gradient: linear-gradient(135deg, #6366f1  0%, #4f46e5 100%);
      --white: #ffffff;
      --text: #1a1a2e;
      --text-light: #555770;
      --text-lighter: #8e8ea0;
      --gray: #f7f7fc;
      --border: #e8e8f0;
      --shadow-sm: 0 2px 12px rgba(0, 0, 0, 0.04);
      --shadow-md: 0 8px 30px rgba(157, 78, 221, 0.10);
      --radius-xl: 20px;
      --radius-lg: 14px;
    }


    body {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
      color: var(--text);
      line-height: 1.7;
      background: #fafaff;
      -webkit-font-smoothing: antialiased;
    }

    .container {
      width: 100%;
      max-width: 820px;
      margin: 0 auto;
      padding: 0 24px;
    }

    /* ----- HEADER (Measro theme) ----- */
    header {
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
      position: sticky;
      top: 0;
      z-index: 1000;
      border-bottom: 1px solid var(--border);
    }

    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 10px;
      text-decoration: none;
    }

    .logo-icon {
      width: 40px;
      height: 40px;
      background: var(--primary-gradient);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 20px;
      box-shadow: 0 4px 12px rgba(157, 78, 221, 0.25);
    }

    .logo-text {
      font-size: 24px;
      font-weight: 800;
      color: var(--text);
      letter-spacing: -0.4px;
    }

    .logo-text span {
      background: var(--primary-gradient);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .back-link {
      text-decoration: none;
      color: var(--text-light);
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all 0.2s ease;
      background: var(--gray);
    }

    .back-link i {
      font-size: 13px;
      transition: transform 0.2s ease;
    }

    .back-link:hover {
      background: var(--primary-bg);
      color: var(--primary);
    }

    .back-link:hover i {
      transform: translateX(-3px);
    }

    /* ----- PAGE CONTENT (Measro styled) ----- */
    .page-content {
      padding: 56px 0 72px;
    }

    .page-content .last-updated {
      display: inline-block;
      font-size: 12px;
      font-weight: 500;
      color: var(--text-lighter);
      background: var(--gray);
      padding: 6px 16px;
      border-radius: 40px;
      margin-bottom: 20px;
      letter-spacing: 0.3px;
      border: 1px solid var(--border);
    }

    .page-content h1 {
      font-size: 2.4rem;
      font-weight: 800;
      color: var(--text);
      margin-bottom: 10px;
      letter-spacing: -0.6px;
      line-height: 1.2;
    }

    .page-content h1 i {
      color: var(--primary);
      margin-right: 10px;
      font-size: 2rem;
    }

    .page-content .intro {
      color: var(--text-light);
      font-size: 1.05rem;
      margin-bottom: 40px;
      padding-bottom: 32px;
      border-bottom: 2px solid var(--border);
      line-height: 1.6;
    }

    .page-content h2 {
      font-size: 1.3rem;
      font-weight: 700;
      color: var(--text);
      margin-top: 40px;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .page-content h2 i {
      color: var(--primary);
      font-size: 1.1rem;
      width: 28px;
      text-align: center;
    }

    .page-content p {
      color: var(--text-light);
      font-size: 15px;
      margin-bottom: 18px;
      line-height: 1.7;
    }

    .page-content ul {
      list-style: none;
      margin-bottom: 20px;
      padding-left: 8px;
    }

    .page-content ul li {
      color: var(--text-light);
      font-size: 15px;
      margin-bottom: 10px;
      padding-left: 28px;
      position: relative;
      line-height: 1.6;
    }

    .page-content ul li::before {
      content: '◆';
      color: var(--primary);
      position: absolute;
      left: 2px;
      font-size: 12px;
      top: 2px;
    }

    .page-content ul li strong {
      color: var(--text);
      font-weight: 600;
    }

    .page-content a {
      color: var(--primary);
      text-decoration: none;
      font-weight: 500;
      border-bottom: 1px solid transparent;
      transition: border-color 0.2s;
    }

    .page-content a:hover {
      border-bottom-color: var(--primary);
      text-decoration: none;
    }

    /* Measro highlight box */
    .page-content .highlight-box {
      background: var(--primary-bg);
      border-radius: var(--radius-lg);
      padding: 22px 28px;
      margin: 32px 0 28px;
      border-left: 4px solid var(--primary);
      box-shadow: var(--shadow-sm);
    }

    .page-content .highlight-box p {
      margin-bottom: 0;
      font-weight: 500;
      color: var(--text);
      font-size: 15px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .page-content .highlight-box p i {
      color: var(--primary);
      font-size: 18px;
      margin-top: 2px;
    }

    /* contact block */
    .contact-block {
      background: var(--gray);
      border-radius: var(--radius-lg);
      padding: 24px 28px;
      margin-top: 24px;
      border: 1px solid var(--border);
    }

    .contact-block ul {
      margin-bottom: 0;
    }

    .contact-block ul li {
      padding-left: 28px;
    }

    .contact-block ul li::before {
      content: '▸';
      color: var(--primary);
      font-size: 14px;
    }

    /* footer */
    footer {
      text-align: center;
      padding: 28px 0 32px;
      color: var(--text-lighter);
      font-size: 13px;
      border-top: 1px solid var(--border);
      background: var(--white);
    }

    footer a {
      color: var(--primary);
      text-decoration: none;
      font-weight: 500;
      margin: 0 6px;
    }

    footer a:hover {
      text-decoration: underline;
    }

    footer .footer-divider {
      color: var(--border);
      margin: 0 6px;
    }

    /* responsive */
    @media (max-width: 640px) {
      .page-content h1 {
        font-size: 1.8rem;
      }
      .page-content {
        padding: 32px 0 48px;
      }
      .header-container {
        flex-wrap: wrap;
        gap: 10px;
      }
      .back-link {
        font-size: 13px;
        padding: 6px 14px;
      }
      .logo-text {
        font-size: 20px;
      }
      .logo-icon {
        width: 34px;
        height: 34px;
        font-size: 16px;
      }
      .page-content .highlight-box {
        padding: 18px 20px;
      }
      .contact-block {
        padding: 18px 20px;
      }
    }

    @media (max-width: 400px) {
      .container {
        padding: 0 16px;
      }
      .page-content h1 {
        font-size: 1.5rem;
      }
      .page-content h2 {
        font-size: 1.1rem;
      }
    }


  `}
</style>




    
    </div>
  );
};

export default Privacy;